export default function MentionedDefaultStyle(
  minHeight,
  isClient,
  isSupportChat
) {
  const addBorderRadius = ['my-bookings/details', 'sales-bookings'].some(path =>
    window.location.pathname.includes(path)
  )
  return {
    control: isClient
      ? {
          backgroundColor: '#fff',
          fontSize: 14,
          fontWeight: 'normal',
        }
      : {
          backgroundColor: '#fff',
          borderRadius: isSupportChat || addBorderRadius ? '4px' : '0px',
          fontSize: 14,
          fontWeight: 'normal',
          maxHeight: isSupportChat ? '500px' : '100px',
        },

    highlighter: {
      overflow: 'hidden',
    },

    input: {
      margin: 0,
      marginLeft: 2,
      width: 'calc(100% - 2px)',
      overflow: 'auto',
    },

    '&singleLine': {
      control: {
        display: 'inline-block',

        width: 130,
      },

      highlighter: {
        padding: 1,
        border: '2px inset transparent',
      },

      input: {
        padding: 1,

        border: '2px inset',
      },
    },

    '&multiLine': {
      control: {
        border: `1px solid ${isClient ? 'rgba(12, 12, 12, 0.1)' : '#C1C1C1'} `,
      },

      highlighter: {
        padding: 9,
      },

      input: {
        padding: 9,
        minHeight: minHeight,
        outline: 0,
        border: 0,
      },
    },

    suggestions: {
      list: {
        position: 'absolute',
        bottom: '100%',
        width: 'max-content',
        'margin-bottom': '26%',
        'margin-left': '35px',
        backgroundColor: 'white',
        border: '1px solid rgba(12, 12, 12, 0.1)',
        fontSize: 14,
      },

      item: {
        padding: '5px 15px',
        borderBottom: '1px solid rgba(12, 12, 12, 0.1)',

        '&focused': {
          backgroundColor: '#cee4e5',
        },
      },
    },
  }
}
